import React from 'react'
import styled from 'styled-components';
import { useTagButton } from './useTagButton';

const StyledTagButton = styled.button`
    border-radius: 20px;
    border: ${props => props.isOn ? "1.5px solid #434343" : "1.5px solid #dbdbdb"};
    padding: .2em .8em;
    transition: all .3s;
    background-color: ${props => props.isOn ? "#cecece52" : "white"};
    color: #212121;
    &:hover {
        scale: 1.05;
    }
`;


export default function TagButton({ children, myTags, setMyTags }) {

    const { handleTagToggle, isOn } = useTagButton(children, setMyTags, myTags);

    return (
        <StyledTagButton onClick={() => {
            handleTagToggle();
        }} isOn={isOn}>{children}</StyledTagButton >
    )
}
